import { render, staticRenderFns } from "./b-ticket-access-info.vue?vue&type=template&id=7c63495f&scoped=true"
import script from "./b-ticket-access-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-access-info.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-access-info.vue?vue&type=style&index=0&id=7c63495f&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63495f",
  null
  
)

export default component.exports